import ClientPage from './page';
import ClientForm from './clientForm';
import PanelClient from './panelClient';

export { ClientForm, PanelClient };
export default ClientPage;
